import { Button, Col } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'

import styles from './styles.module.css'

function VehicleCard({ data, id, title, subtitle, seeMore, urlEdit }) {
  const navigate = useNavigate()
  return (
    <Col className={styles.card} md={5} lg={4} xl={2}>
      <div className={styles.cardInfoGroup}>
        <span className={styles.title}>{title}</span>
        <span className={styles.subtitle}>{subtitle}</span>

        {Object.keys(data).map((key, index) => (
          <span key={index} className={styles.infoSpan}>
            <strong>{key}: </strong>
            {data[key] ? data[key] : 'Não informado'}
          </span>
        ))}
      </div>
      <div className={styles.cardBtnGroup}>
        <Button className={styles.cardBtn} onClick={seeMore}>
          Ver mais informações
        </Button>
        <Button className={styles.cardBtn} onClick={() => navigate(`${urlEdit}/${id}`)}>
          Editar
        </Button>
      </div>
    </Col>
  )
}

export default VehicleCard
